import Select from 'react-select-plus'
import { compose, withHandlers, withProps } from 'recompose'

const SelectContainer = compose(
  withProps(() => ({
    clearable: false,
    placeholder: 'Enter value',
  })),
  withHandlers({
    onChange: props => ({ value }) => props.onChange(value),
  })
)(Select)

export default SelectContainer



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingDisplay/SelectContainer.js